import { ReactElement } from 'react';

import { SignatureFrame } from '../../../../IframePopUp/AssinaturaFrame';
import { useUpdateDependentForm } from '../../../../../contexts/UpdateDependentFormProviderGdf';
import { useError } from '../../../../../stores/useError';
import { useLinkStore } from '../../../../../stores/useLinkStore';
import { useLoadingStore } from '../../../../../stores/useLoadingStore';
import { CartIcon } from '../../../../icons/CartIcon';
import Loading from '../../../../icons/Loading';
import { ErrorModal } from '../../../../Modal/Modal';
import { GoForwardButton } from '../../../GoForwardButton';
import { GdfAcceptanceContent } from '../../../shared/AcceptanceContent';

export function AceiteForm(): ReactElement {
  const { handleSubmit, onSubmit } = useUpdateDependentForm();

  const loading = useLoadingStore(state => state.loading);
  const error = useError(state => state.error);
  const title = useError(state => state.title);
  const text = useError(state => state.text);
  const Iframe = useLinkStore(state => state.data);

  return (
    <form
      action=""
      className="max-w-[766px] w-full"
      onSubmit={handleSubmit(onSubmit)}
    >
      {error && <ErrorModal open={true} title={title} text={text} />}
      {Iframe ? (
        <>
          <h2 className="text-[2rem] font-semibold text-center text-primary-main notranslate">
            Termo de aceite
          </h2>
          <SignatureFrame src={Iframe} />
        </>
      ) : (
        <>
          <GdfAcceptanceContent />
          <GoForwardButton
            disabled={loading}
            addBackButton
            Icon={loading ? Loading : CartIcon}
            desktopText={loading ? '' : 'Concordar com os Termos'}
            mobileText={loading ? '' : 'Concordar com os Termos'}
          />
        </>
      )}
    </form>
  );
}
